module.exports = __webpack_public_path__ + "img/play-button.0a3a2fad.png";